// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search__interests[data-v-504f3dec]{background-color:#fff;transition:.4s;padding-top:34px;padding-bottom:34px}.search__interests.expanded[data-v-504f3dec]{background-color:#f7f7f7}.search__interests span[data-v-504f3dec]{margin-bottom:20px;display:block}", ""]);
// Exports
module.exports = exports;
